var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgHardwareDc = function SvgHardwareDc(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hardware-dc_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 20c5.523 0 10-4.477 10-10S55.523 0 50 0 40 4.477 40 10s4.477 10 10 10Z",
    fill: "#FEDB01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 60H0V10h45.452c2.5 0 4.532 2.011 4.532 4.486V60H50Z",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 15h10v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CED9",
    d: "M20 15h10v10H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A9DFF",
    d: "M35 15h10v10H35zM5 30h10v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CED9",
    d: "M20 30h10v10H20zm15 0h10v10H35zM5 45h10v10H5zm15 0h10v15H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 55c-1.106 0-2-.894-2-2 0-1.106.894-2 2-2a2 2 0 0 1 0 4Z",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A9DFF",
    d: "M35 45h10v10H35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.913 9.885a6.083 6.083 0 0 1-4.792-4.786c-.016-.132-.197-.132-.23 0a6.082 6.082 0 0 1-4.792 4.786c-.132.016-.132.197 0 .23a6.083 6.083 0 0 1 4.792 4.786c.016.132.198.132.23 0a6.083 6.083 0 0 1 4.792-4.786c.116-.033.116-.214 0-.23zM35.023 35l11.473 25H29.978l5.045-25z",
    fill: "#345795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 35H35v25h25V37a2 2 0 0 0-2-2Z",
    fill: "#5A9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 45.822h2.932a.34.34 0 0 1 .323.444L49.433 52 56 43.782h-3.37a.34.34 0 0 1-.314-.47L54.501 38h-4L48 45.822Z",
    fill: "#FEDB01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EBEF",
    d: "M43 50h2v10h-2zm-4 0h2v10h-2zm-4 0h2v10h-2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hardware-dc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};

export default SvgHardwareDc;